import { CoSyncOperateStatus, CoSyncResultCode } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncEvent';
import { OperateTaskInfo } from '@/workerProcessRenderer/scripts/CoSyncEngine/Operator/typings';

export type CoSyncOperateDrawerItemStatus = 'waiting' | 'running' | 'success' | 'stopped' | 'error';

export function getCoSyncOperateItemStatus(taskInfo: OperateTaskInfo): CoSyncOperateDrawerItemStatus | undefined {
  switch (taskInfo.status) {
    case CoSyncOperateStatus.TYPE_INIT:
    case CoSyncOperateStatus.TYPE_WAILTING:
      return 'waiting';

    case CoSyncOperateStatus.TYPE_RUNNING:
    case CoSyncOperateStatus.TYPE_START:
    case CoSyncOperateStatus.TYPE_HASH_COMPUTE: {
      return 'running';
    }

    case CoSyncOperateStatus.TYPE_FINISH: {
      if (taskInfo.result === undefined) return undefined;
      if (taskInfo.result === CoSyncResultCode.CODE_SUCCESS) {
        return 'success';
      }
      return 'error';
    }

    case CoSyncOperateStatus.TYPE_STOP: {
      return 'stopped';
    }

    case CoSyncOperateStatus.TYPE_UPDATE_TREE:
    case CoSyncOperateStatus.TYPE_GROUP_FINISH:
    case CoSyncOperateStatus.TYPE_OPERATE_FINISH: {
      return undefined;
    }

    default: {
      const _exhaustiveCheck: never = taskInfo.status;
      return _exhaustiveCheck;
    }
  }
}
